module.exports = __webpack_public_path__ + "assets/img/qrCode.a504eefe.png";